/**
 * Logos component
 * ---------------
 */

/* Imports */

import React from "react";
import { Logos } from "./styles.module.scss";

/* Variables */

const brands = [
  "Instagram",
  "Pinterest",
  "TikTok",
  "Squarespace",
  ["PicMonkey", "Fohr"],
];

/* Component */

const LogosComponent = () => {
  let d = 0;

  const logo = (t, i) => {
    let h = "r";

    if (t === "Pinterest" || t === "Instagram" || t === "PicMonkey") h = "l";

    if (t === "Fohr") h = "s";

    const output = (
      <div className="lc-flex" key={`lo-${i}`}>
        <div className="lc-v-h">{t}</div>
        <img
          className="lc-move-fade-y lc-vis"
          data-delay={d}
          src={`../../../../latercon/2021/svg/logos/${t.toLowerCase()}.svg`}
          data-h={h}
          alt=""
        />
      </div>
    );

    d += 50;

    return output;
  };

  return (
    <>
      <span className="lc-v-h">Including industry professionals from </span>
      <div
        className={`${Logos} lc-logos lc-flex`}
        data-align="center"
        data-justify="center"
        data-gap="r"
        data-mobile
        data-wrap
      >
        {brands.map((b, i) => {
          if (Array.isArray(b)) {
            return (
              <div key={`lo-${i}`}>
                <div>
                  <div
                    className="lc-flex"
                    data-align="center"
                    data-justify="center"
                    data-gap="r"
                    data-mobile
                  >
                    {b.map((bb, ii) => logo(bb, ii))}
                  </div>
                </div>
              </div>
            );
          }
          return logo(b, i);
        })}
      </div>
    </>
  );
};

/* Export */

export default LogosComponent;
